import React from 'react'
import {useSelector} from "react-redux"
import Error from "../../global/Error/Error"

const StepError = () => {
  const error: string = useSelector((state: Storage) => state.cvEditor.stepError)
  return <Error errorMessage={error} />
}

export default StepError